export const IsPasswordType = state => state.SignIn.passshown
export const IsCurrentPassType = state => state.SignIn.currentpass
export const IsNewPassType = state => state.SignIn.newpass
export const IsConfirmPassType = state => state.SignIn.confirmpass

export const IsSignUpSlideType = state => state.SignIn.currentSignupStep